// extracted by mini-css-extract-plugin
export var centerText = "_7j-8";
export var container = "_7j-0";
export var doughnutContainer = "_7j-7";
export var legend = "_7j-a";
export var legendItemColorDisplay = "_7j-b";
export var legendItemLabel = "_7j-d";
export var legendItemValue = "_7j-c";
export var lg = "_7j-5";
export var maxWidth = "_7j-9";
export var md = "_7j-4";
export var responsive = "_7j-6";
export var sm = "_7j-3";
export var xs = "_7j-2";
export var xxs = "_7j-1";